import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { Eyebrow, Reveal } from "@/components/Primitives";

const STEPS = [
  ["Tell us about your business", "A two-minute form: what you sell, how you take payments and roughly how much."],
  ["We review your statement", "We go line by line through your current processing statement and flag markups and extra fees."],
  ["Get a clear proposal", "Side-by-side pricing in plain English. If we can't save you money, we'll tell you."],
  ["Switch with setup help", "Equipment, gateway and payroll setup handled with you, on your schedule."],
];

export const StatementReview = ({ onSelect }) => (
  <section id="review" className="pb-24 lg:pb-36" data-testid="statement-review-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-5">
          <div className="relative h-full min-h-[360px] rounded-[32px] overflow-hidden">
            <img src={IMAGES.review} alt="Reviewing a merchant processing statement" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220] via-[#0B1220]/60 to-transparent" />
            <div className="absolute bottom-0 p-7 sm:p-9 text-white">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-200">Free · No obligation</p>
              <p className="mt-2 font-display text-3xl font-semibold leading-tight">Most statements hide more than they show.</p>
            </div>
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div className="h-full rounded-[32px] bg-[#E7ECFF] p-7 sm:p-10 lg:p-12 flex flex-col">
            <Eyebrow>04 — Free statement review</Eyebrow>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.04]">
              Send us your statement. <span className="font-serif-i text-[var(--cobalt)]">We'll find the fat.</span>
            </h2>
            <ol className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-8">
              {STEPS.map(([t, d], i) => (
                <li key={t} className="flex gap-4" data-testid={`review-step-${i}`}>
                  <span className="font-mono text-sm font-semibold text-[var(--cobalt)] pt-1">0{i + 1}</span>
                  <div>
                    <h3 className="font-display text-lg font-semibold">{t}</h3>
                    <p className="mt-1 text-sm text-slate-700 leading-relaxed">{d}</p>
                  </div>
                </li>
              ))}
            </ol>
            <button
              onClick={onSelect}
              data-testid="review-cta"
              className="mt-12 self-start group inline-flex items-center gap-3 rounded-full bg-[var(--ink)] text-white px-7 py-4 font-semibold hover:bg-[var(--cobalt)] transition-colors"
            >
              Request my free statement review
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
